import { csx } from '@vtex/admin-ui'

const styles = {
  utmFields: csx({
    rowGap: '$space-5',
    flexDirection: 'column',
    marginBottom: '$space-6',
    '> *': { width: 'full' },
  }),
}

export default styles
